module.exports = "/_next/static/images/desktop_menu_dev-09f6f7331f8e688d49ed7c1f64e8b471.png";